import { AfterViewInit, Component, Inject, Input, OnChanges, OnInit, SimpleChanges, TemplateRef, ViewContainerRef } from '@angular/core';
import { PanelData } from '../custom-dashboard/custom-dashboard.component';
import { DOCUMENT } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { AssetsDataService } from '@services/assets-data.service';
import { IntegrationSensorsService } from '@services/integration-sensors.service';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { OrganisationDashboard } from '@services/organisation-data.service';
import { PanelModel } from '@syncfusion/ej2-angular-layouts';

@Component({
	selector: 'app-dashboard-viewer',
	templateUrl: './dashboard-viewer.component.html',
	styleUrl: './dashboard-viewer.component.scss'
})
export class DashboardViewerComponent implements OnInit, OnChanges, AfterViewInit {

	/** publicPanelData */
	@Input() public publicPanelData: PanelData[];

	/** panelInfo */
	@Input() public panelInfo: any[];

	/** selectedDashboard */
	@Input() public selectedDashboard: OrganisationDashboard;

	/** panels */
	public panels: PanelModel[] = [];

	/** columns */
	public columns: number = 10;

	/** rows */
	public rows: number = 10;

	/** templates */
	@Input() public templates: TemplateRef<any>[];

	/** hierarchyTemplates */
	@Input() public hierarchyTemplates: TemplateRef<any>[];

	/** container */
	@Input() public container: HTMLElement;

	/** isFullScreen */
	@Input() public isFullScreen: boolean;

	/**
	 * Default Constructor
	 * @param globalFunctions globalFunctions 
	 * @param siteSubscriptions siteSubscriptions 
	 * @param assetsDataService assetsDataService 
	 * @param integrationSensorsService integrationSensorsService 
	 * @param document document 
	 */
	constructor(
		public globalFunctions: GlobalFunctions,
		private siteSubscriptions: siteSubscriptions,
		private assetsDataService: AssetsDataService,
		private integrationSensorsService: IntegrationSensorsService,
		@Inject(DOCUMENT) public document: Document
	) {
		// console.log("");
	}

	/**
	 * ngAfterViewInit
	 */
	ngAfterViewInit(): void {
		this.loadDashboard(this.selectedDashboard);
	}

	/**
	 * ngOnInit
	 */
	ngOnInit(): void {
	}

	/**
	 * ngOnChanges
	 * @param changes changes 
	 */
	ngOnChanges(changes: SimpleChanges): void {
		if (changes["selectedDashboard"]) {
			this.loadDashboard(this.selectedDashboard);
		}
	}

	/**
	 * caclulateRowsAndColumns
	 * @param panels panels 
	 */
	caclulateRowsAndColumns(panels: PanelModel[]) {
		let furthestRight: number = 0;
		let furthestDown: number = 0;
		panels.forEach((panel: PanelModel) => {
			const rightVal: number = panel.col! + panel.sizeX!;
			const downVal: number = panel.row! + panel.sizeY!;
			furthestRight = rightVal > furthestRight ? rightVal : furthestRight;
			furthestDown = downVal > furthestDown ? downVal : furthestDown;
		});
		this.columns = furthestRight;
		this.rows = furthestDown;
	}

	/**
	 * getPanelInfo
	 * @param id id  
	 * @returns 
	 */
	getPanelInfo(id: string): any {
		return this.panelInfo.find((x) => x.id == id);
	}

	/**
	 * getPanelHeight
	 * @param container container 
	 * @param panel panel 
	 */
	getPanelHeight(panel: PanelModel): string {
		if (!this.isFullScreen) {
			const titleElement = this.container.getElementsByClassName("dashboard-title")[0];
			const height: number = ((this.container.offsetHeight - titleElement.clientHeight) / this.rows) * panel.sizeY!;
			return `${height * 0.95}px`;
		} else {
			const titleElement = this.container.getElementsByClassName("fullscreen-watermark")[0];
			const height: number = ((this.container.offsetHeight - titleElement.clientHeight) / this.rows) * panel.sizeY!;
			return `${height * 0.95}px`;
		}
	}

	/**
	 * loadDashboard
	 * @param dashboard dashboard 
	 */
	loadDashboard(dashboard: OrganisationDashboard) {
		this.panels = dashboard.DashboardConfig.map((x) => x.panel);
		this.caclulateRowsAndColumns(this.panels);
	}

	/**
	 * getTemplateContext
	 * @param info info 
	 */
	getTemplateContext(info: any): any {
		return {
			data:
			{
				...info.context,
				isHierarchy:
					info.isHierarchy,
				barDefault: info.barDefault ?? false,
				id: info.id
			}
		}
	}
}
